import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
import baseButtonDefaults from '../BaseButton/BaseButton.defaults'
import baseFieldDefaults from '../BaseField/BaseField.defaults'
import baseLabelDefaults from '../BaseLabel/BaseLabel.defaults'

export default {

  ...cloneDeep(baseDefaults),

  confirmTitle: 'Your order is confirmed!',
  confirmText: 'Your order is confirmed and will be shipped.'
  
}